export const DEFAULT_BLURRED_VIDEO_BACKGROUND_WIDTH = 766;
export const DEFAULT_BLURRED_VIDEO_BACKGROUND_HEIGHT = 471;
